import EditEventModal from './EditEventModal.component'

export default EditEventModal
